"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const WrapListener = function () {
  for (var _len = arguments.length, listeners = new Array(_len), _key = 0; _key < _len; _key++) {
    listeners[_key] = arguments[_key];
  }
  return event => listeners.map(listener => typeof listener === 'function' && listener(event));
};
var _default = WrapListener;
exports.default = _default;